<div [formGroup]="group">
  <div>
    @if (group.get(config.name); as field) {
      <mat-form-field
        [appearance]="config.appearance || 'fill'"
        [color]="config.color || 'accent'"
        [class.has--label]="!!config.label"
        [class.has--sub-label]="!!config.subLabel"
        [subscriptSizing]="config.subscriptSizing || 'fixed'"
      >
        <mat-label>{{ config.label }}</mat-label>
        <mat-select [formControlName]="config.name" [placeholder]="config.placeholder || ''">
          <mat-option>
            <ngx-mat-select-search
              [noEntriesFoundLabel]="config['search']?.['noResultsFound'] || ('formulier-zoek-geen-resultaten' | fromDictionary)"
              [placeholderLabel]="config['search']?.['placeholder'] || ('formulier-zoek-placeholder' | fromDictionary)"
              #selectSearch
            ></ngx-mat-select-search>
          </mat-option>

          @for (option of filteredOptions(selectSearch?.value || ''); track $index) {
            <!--@for (option of config.selectOptions; track option) {-->
            <mat-option [value]="option.id">
              @if (option.icon) {
                <img width="30" src="https://flagcdn.com/{{ option.icon }}.svg" [alt]="option.title + ' flag'" />
              }

              <span>{{ option.title }}</span>
            </mat-option>
          }
        </mat-select>
        @if (field.invalid) {
          <mat-error>
            {{ field | formError: config.customValidationMessages }}
            @if (config.helpLink; as help) {
              <a class="d-md-none" [href]="help.url">
                {{ help.title }}
              </a>
            }
          </mat-error>
        }
      </mat-form-field>
    }
  </div>
</div>
